import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyAzKOy_N8JfvhfMz6inzTVEmiUqORy3lxg",
  authDomain: "vwagency-18c62.firebaseapp.com",
  projectId: "vwagency-18c62",
  storageBucket: "vwagency-18c62.firebasestorage.app",
  messagingSenderId: "1038467682069",
  appId: "1:1038467682069:web:d0ea211aca47226833631c"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore
const db = getFirestore(app);

export { db };
export default app; 